/*@ngInject*/
const Localization = function ($http, $q, $window, umsLog) {
    let loadDefault = true,
        isLoading = false,
        defer = null,
        translations = null;

    this.getTranslationByKey = function (key) {
        let keyDefer = $q.defer();

        function handleSuccess(translations) {
            let localizedString = '';
            if (key) {
                localizedString = _.get(translations, key.trim());
                if (_.isEmpty(localizedString)) {
                    umsLog.info('Can\'t find localized string for key: ' + key);
                }
            }
            keyDefer.resolve(localizedString);
        }

        function handleError(error) {
            keyDefer.reject(error);
        }

        this.getTranslations().then(handleSuccess, handleError);
        return keyDefer.promise;
    };

    this.getTranslationsByKeys = function (keys) {
        let defer = $q.defer(),
            promiseList = [];

        _.each(keys, function (key) {
            if (!_.isNil(key)) {
                promiseList.push(this.getTranslationByKey(key));
            }
        }.bind(this));

        $q.all(promiseList).then(function (results) {
            let mergedTranslations = {};

            _.each(results, function (result) {
                // Order of merge matters here, we want keys in the list that have lower index to overwrite higher index entries.
                mergedTranslations = _.merge(_.cloneDeep(result), mergedTranslations);
            });

            defer.resolve(mergedTranslations);
        });

        return defer.promise;
    };

    this.getTranslations = function () {
        function loadLocalizationFile(language) {
            let url = 'localization/' + language + '/localization.json';

            function loadLanguageFileSuccess(result) {
                return result;
            }

            function loadLanguageFileError(error) {
                if (loadDefault) {
                    loadDefault = false;
                    return loadLocalizationFile('en-US');
                } else {
                    return $q.reject(error);
                }
            }

            return $http.get(url).then(loadLanguageFileSuccess, loadLanguageFileError);
        }

        function handleSuccess(response) {
            isLoading = false;
            translations = response.data;
            if (defer) {
                defer.resolve(translations);
            }
            defer = null;
        }

        function handleError(error) {
            isLoading = false;
            return defer.reject(error);
        }

        if (_.isNull(defer)) {
            defer = $q.defer();
        }

        if (isLoading) {
            return defer.promise;
        } else if (translations) {
            defer.resolve(translations);
        } else {
            isLoading = true;
            let language = $window.navigator.language;
            loadLocalizationFile(language).then(handleSuccess.bind(this), handleError);
        }

        return defer.promise;
    };

    this.setupLocale = (namespace, resourceBundle) => {
        const namespaceExists = i18n.hasResourceBundle('en-US', namespace);

        if(!namespaceExists) {
            i18n.loadNamespaces(namespace);
        }

        i18n.addResourceBundle('en-US', namespace, resourceBundle, true, true);
    };
};

angular.module('umCore')
    .service('localization', Localization);
